// extracted by mini-css-extract-plugin
module.exports = {"modal":"U5_rw","show":"_1Io5a","title":"_2Vsiw","cross":"_2UPLT","modalTitle":"MXJne","form":"WcFK9","modalBackDrop":"_1m1MP"};